/* ═══════════════════════════════════════════════════
   JACQUARD DESIGN SYSTEM — Web Kit (TS entry)
   Version 4.0 · Phase 2

   All primitives are driven by tokens (CSS variables) and
   kit.css component classes. Consumers:
     import { Button, Modal } from '@atelierpx/jacquard/kit';
   ═══════════════════════════════════════════════════ */

export * from './utils';
export { type Density, FormDensityContext, useFormDensity } from './density';
export * from './primitives/Eyebrow';
export * from './primitives/DisplayNum';
export * from './primitives/Title';
export * from './primitives/Text';
export * from './primitives/SectionHeader';
export * from './primitives/Label';
export * from './primitives/Divider';
export * from './primitives/Badge';
export * from './primitives/IdTag';
export * from './primitives/StatCell';
export * from './primitives/Empty';
export * from './primitives/Thumb';
export * from './primitives/LayerScope';
export * from './primitives/Card';
export * from './primitives/Progress';
export * from './primitives/Modal';
export * from './primitives/Button';
export * from './primitives/Link';
export * from './primitives/IconButton';
export * from './primitives/FAB';
export * from './primitives/Field';
export * from './primitives/Input';
export * from './primitives/Textarea';
export * from './primitives/Select';
export * from './primitives/MultiSelectField';
export * from './primitives/CreatableSelect';
export * from './primitives/Checkbox';
export * from './primitives/Radio';
export * from './primitives/SearchInput';
export * from './primitives/SegmentedControl';
export * from './primitives/Switch';
export * from './primitives/Toggle';
export * from './primitives/Menu';
export * from './primitives/SplitButton';
export * from './primitives/Toast';
export * from './primitives/Tooltip';
export * from './primitives/Skeleton';
export * from './primitives/Spinner';
export * from './primitives/AccordionTrigger';
export * from './primitives/Collapsible';
export * from './primitives/Table';
export * from './primitives/BulkActionBar';
export * from './primitives/ColorPanel';
export * from './primitives/ColorPicker';
export * from './primitives/DatePicker';
export * from './primitives/Rating';
export * from './primitives/TimePicker';
export * from './primitives/Transfer';
export {
  DropdownMenu,
  MenuDivider as DropdownMenuDivider,
  MenuItem as DropdownMenuItem,
  type DropdownMenuProps,
  type MenuItemProps as DropdownMenuItemProps,
} from './primitives/DropdownMenu';
export * from './primitives/ImageField';
export * from './primitives/InlineEdit';
export * from './primitives/LedgerRow';
export * from './primitives/MetricDisplay';
export * from './primitives/Popover';
export {
  FilterButton,
  FilterGroup,
  useFilterButton,
  type FilterButtonProps,
  type FilterButtonValueDisplay,
  type FilterGroupProps,
  type UseFilterButtonOptions,
  type UseFilterButtonReturn,
} from './primitives/FilterButton';
export * from './primitives/FormField';
export * from './primitives/FieldGroup';
export * from './primitives/Form';
export * from './primitives/JacquardProvider';
export * from './primitives/JacquardI18nProvider';
export * from './primitives/JacquardRoot';
export {
  JacquardIconProvider,
  type IconOverrides,
  type JacquardIconProviderProps,
} from './primitives/JacquardIconProvider';
export { JacquardScript } from './primitives/JacquardScript';
export {
  COOKIE_KEYS,
  readCookie,
  type CookieKey,
  type ThemeValue,
  type DirectionValue,
} from '../cookies/schema';
export * from './dialogs/useConfirm';
export * from './dialogs/imperative';
export * from './hooks/useIsMobile';
export * from './hooks/useBreakpoint';
export * from './hooks/useStableId';
export type * from './types';
/* Runtime helpers from types.ts. `export type *` above only re-exports
   type-only declarations; runtime exports must be listed explicitly.
   Audit #9 (2026-05-16): codex caught that `tintVar` was reachable in
   the rolled-up .d.ts but missing from the JS export list, so adopters
   could `import { tintVar }` and fail at module load. */
export { tintVar, TINT_NAMES, PROGRESS_TINTS } from './types';
export type { UnsafeProps } from './escape-hatches';
export { warnIfExternal } from './escape-hatches';
export { JIcon, type JIconProps, ICON_REGISTRY, type IconIntent, useIconRegistry } from '../icons';
